import { render, staticRenderFns } from "./KeepCleanInfo.vue?vue&type=template&id=5c1f5810&scoped=true&"
import script from "./KeepCleanInfo.vue?vue&type=script&lang=js&"
export * from "./KeepCleanInfo.vue?vue&type=script&lang=js&"
import style0 from "./KeepCleanInfo.vue?vue&type=style&index=0&id=5c1f5810&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1f5810",
  null
  
)

export default component.exports